import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'Martín González',
  role: 'Entrenador formativo',
  city: 'Buenos Aires',
  text: 'Antes llegaba a la cancha improvisando. Con la planificación anual y los entrenamientos listos, ahora cada sesión tiene un objetivo claro y mis chicos progresan parejo.',
  rating: 5
}, {
  name: 'Lucas Fernández',
  role: 'Entrenador categoría infantil',
  city: 'Córdoba',
  text: 'El módulo infantil me cambió la forma de enseñar. Dejé de saltar pasos y los fundamentos quedan sólidos. El banco de 50 ejercicios es oro puro.',
  rating: 5
}, {
  name: 'Santiago Rodríguez',
  role: 'Entrenador juvenil',
  city: 'Rosario',
  text: 'Los tomos de defensa y sistemas ofensivos me ordenaron la cabeza. Ahora corrijo errores técnicos en el momento porque sé exactamente qué buscar.',
  rating: 5
}, {
  name: 'Nicolás Pérez',
  role: 'Director técnico de club',
  city: 'Mendoza',
  text: 'La planilla de scouting y estadísticas me hizo ver el juego de otra manera. Tomo decisiones con datos y no a ojo. Vale cada peso.',
  rating: 5
}, {
  name: 'Facundo López',
  role: 'Entrenador amateur',
  city: 'La Plata',
  text: 'La guía de comunicación con padres me sacó un peso de encima. Y la evaluación individual me deja mostrar el progreso real de cada jugador.',
  rating: 5
}];
export function Testimonials() {
  return <section className="w-full bg-blue-50 py-12 md:py-16 px-4" data-id="element-164">
      <div className="max-w-6xl mx-auto" data-id="element-165">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-166">
          Lo que dicen otros entrenadores
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-167">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-6 rounded-lg shadow-md" data-id="element-168">
              <div className="flex gap-1 mb-3" data-id="element-169">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-orange-500 text-orange-500" data-id="element-170" />)}
              </div>
              <p className="text-gray-700 mb-4 italic" data-id="element-171">"{testimonial.text}"</p>
              <div className="border-t pt-4" data-id="element-172">
                <p className="font-bold text-gray-900" data-id="element-173">{testimonial.name}</p>
                <p className="text-sm text-gray-600" data-id="element-174">
                  {testimonial.role} • {testimonial.city}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}